<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import tdTheme from "./theme.json";
import "../map/fujian.js";

export default {
  name: "echart",
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "2.5rem",
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      chart: null,
      resizeObserver: null,
    };
  },
  watch: {
    options: {
      handler(options) {
        if (!this.chart) return;
        this.chart.setOption(options, true);
        this.$nextTick(() => {
          this.resizeChart();
        });
      },
      deep: true,
    },
    width() {
      this.$nextTick(() => {
        this.resizeChart();
      });
    },
    height() {
      this.$nextTick(() => {
        this.resizeChart();
      });
    },
  },
  mounted() {
    this.$echarts.registerTheme("tdTheme", tdTheme);
    this.initChart();
    window.addEventListener("resize", this.resizeChart);
    this.bindResizeObserver();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$el, "tdTheme");
      this.chart.setOption(this.options, true);
      this.$nextTick(() => {
        this.resizeChart();
      });
    },
    resizeChart() {
      if (this.chart && typeof this.chart.resize === "function") {
        this.chart.resize();
      }
    },
    bindResizeObserver() {
      if (typeof ResizeObserver === "undefined") return;
      this.resizeObserver = new ResizeObserver(() => {
        this.resizeChart();
      });
      this.resizeObserver.observe(this.$el);
    },
  },
};
</script>

<style></style>

